// import { PartRes } from "@/types/types";
import React, { createContext } from "react";

type PageLoaderContextProps = {
  isPageLoading: boolean;
  setIsPageLoading: React.Dispatch<React.SetStateAction<boolean>>;
  updateIsLoadingHandler: (
    e?:
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => void;
  updateIsLoadingTrueHandler: (
    e?: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
};

const PageLoaderContext = createContext<PageLoaderContextProps>({
  isPageLoading: false,
  setIsPageLoading: () => {},
  updateIsLoadingHandler: () => {},
  updateIsLoadingTrueHandler: () => {}
});

export default PageLoaderContext;
